'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Vivus = require("vivus");
var Loading;
(function (Loading) {
    var MyLoading = /** @class */ (function () {
        function MyLoading() {
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            var self = this;
            var scrollOff = function (e) {
                e.preventDefault();
            };
            window.addEventListener('touchmove', scrollOff, { passive: false });
            this.changeFixedWindow();
            var options = {
                duration: 12,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var stroke01 = new Vivus('bulletLoadingLine01', options, function () { });
            var stroke02 = new Vivus('bulletLoadingLine02', options, function () { });
            stroke01.stop();
            stroke02.stop();
            var topLineOptions = {
                duration: 100,
                start: 'manual',
                type: 'oneByOne',
                forceRender: false
            };
            var topStroke = new Vivus('bulletTopFirstAnimation', topLineOptions, function () { });
            topStroke.stop();
            var wait = function (milliseconds) { return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); }); };
            $(window).on('load', function () {
                // 一時的に入れている。後で消す ↓
                // self.changeNotFixedWindow();
                self.scrollTop();
                $('.bulletLoadShow').css('opacity', '1');
                if (self.isSpWidth()) {
                    Promise.resolve()
                        .then(function () { return self.changeDataActive('bulletLoadingTitle01'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return self.changeDataActive('bulletLoadingTitle02'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return stroke01.play(); })
                        .then(function () { return wait(500); })
                        .then(function () { return stroke02.play(); })
                        .then(function () { return wait(1500); })
                        .then(function () { return self.changeNotFixedWindow(); })
                        .then(function () { return wait(1000); })
                        .then(function () { return self.changeDataActive('bulletTopSecondAnimation'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return self.changeDataActive('bulletTopThirdAnimation'); })
                        .then(function () { return window.removeEventListener('touchmove', scrollOff, {}); });
                }
                else {
                    Promise.resolve()
                        .then(function () { return self.changeDataActive('bulletLoadingTitle01'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return self.changeDataActive('bulletLoadingTitle02'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return stroke01.play(); })
                        .then(function () { return wait(500); })
                        .then(function () { return stroke02.play(); })
                        .then(function () { return wait(1500); })
                        .then(function () { return self.changeNotFixedWindow(); })
                        .then(function () { return wait(300); })
                        .then(function () { return topStroke.play(); })
                        .then(function () { return wait(1500); })
                        .then(function () { return self.changeDataActive('bulletTopSecondAnimation'); })
                        .then(function () { return wait(1000); })
                        .then(function () { return self.changeDataActive('bulletTopThirdAnimation'); })
                        .then(function () { return window.removeEventListener('touchmove', scrollOff, {}); });
                }
            });
        }
        MyLoading.prototype.scrollTop = function () {
            $("html, body").scrollTop(0);
        };
        MyLoading.prototype.changeDataActive = function (name) {
            $('.' + name).attr('data-active', 'true');
        };
        MyLoading.prototype.changeFixedWindow = function () {
            $('html, body').css('overflow', 'hidden');
        };
        MyLoading.prototype.changeNotFixedWindow = function () {
            this.scrollTop();
            $('.bulletLoading').fadeOut('slow', function () {
                $('html, body').css('overflow', 'auto');
            });
        };
        MyLoading.prototype.isSpWidth = function () {
            var flag = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth < this.OVERPCWIDTH) {
                flag = true;
            }
            return flag;
        };
        return MyLoading;
    }());
    Loading.MyLoading = MyLoading;
})(Loading || (Loading = {}));
exports.default = Loading;
